import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSort } from '@angular/material/sort';
import { DataBagService } from 'src/app/common/data-bag.service';

export interface PeriodicElement {
	name: string;
	weight: number;
	symbol: string;
}

@Component({
	selector: 'app-location-multimedias',
	templateUrl: './location-multimedias.component.html',
	styleUrls: ['./location-multimedias.component.css'],
})
export class LocationMultimediasComponent {
	@Input() data: any;
	@Input() editable = true;
	@Output() dataChanged = new EventEmitter();

	@ViewChild('dataTable') table: MatTable<PeriodicElement>;
	@ViewChild(MatSort) sort: MatSort;

	displayedColumns: string[] = [`url`, 'name', `order`, 'link', `edit`];
	constructor(private readonly bag: DataBagService) {}
	dropTable(event: CdkDragDrop<PeriodicElement[]>): void {
		moveItemInArray(this.data.multimedia, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}

	uploadFile(event) {
		this.bag.upload('/multimedia/file/', event.target.files[0], (result, error) => {
			this.data.multimedia.push({
				id: null,
				multimedia: result,
				order: this.data.multimedia.length + 1,
			});

			this.table.renderRows();
		});
	}

	deleteImage(index) {
		this.data.multimedia.splice(index, 1);
		this.table.renderRows();
	}
}
